import React from 'react'
import PropTypes from 'prop-types'
import clearProps from '../../utils/clearProps'
// import { Container } from './styles';

function Select(props) {
  const { id, disabled, children, onChange, options, value, parentProps, label, ...rest } = props
  const [currentValue, setCurrentValue] = React.useState(value)
  const option = React.useRef('')
  const _rest = clearProps(rest)

  const selfId =
    id ||
    `${new Date()
      .valueOf()
      .toString()
      .match(/\d{6}$/)[0]
    }`


  const handleChange = (event) => {
    setCurrentValue(event.target.value.trim())
    !!onChange && onChange(event)
  }

  return (
    <div
      {...parentProps}
      className={`mdn-Input mdn-Select
       ${currentValue ? 'mdn-Input--activatedField' : ''}`}
    >
      <select
        id="search"
        className="mdn-Input-field"
        type="text"
        ref={option}
        value={currentValue}
        data-mdn-type="select"
        disabled={disabled}
        onChange={handleChange}

        {..._rest}
      >
        {children ||
          options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      <label htmlFor={selfId} className="mdn-Input-label">
        {label}
      </label>
      <small className="mdn-Input-errorFeedback">
        Por favor, preencha este campo corretamente.
      </small>
    </div>
  )
}

Select.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node,
  value: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  )
}

export default Select
